import { MediaFromStrategyIcon } from '@/svgs'
import React from 'react'

function MediaFromStrategy() {
   return (
      <section id="development-guide-section" className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Creativity to Engagement: Our Media & Entertainment Software
               Development Process
            </h2>

            <p className="section_desc">
               With 12+ years of expertise in media and entertainment software
               development, we build seamless, scalable, and high-performance
               solutions. Our structured approach enhances content delivery,
               optimizes user engagement, and drives immersive experiences.
            </p>

            <MediaFromStrategyIcon />
         </div>
      </section>
   )
}

export default MediaFromStrategy
